import React, {
  useState,
  useEffect,
  useMemo,
  Fragment,
  useRef,
  useContext,
} from "react";

import "../Scss/ClientStyles.scss?v=1.1.3";
import {
  NavLink,
  Redirect,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import {
  Alert,
  ButtonGroup,
  Button,
  Box,
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  Switch,
  Autocomplete,
  Fade,
  Divider,
  Typography,
  List,
  ListItem,
  ListItemText,
  Card,
  CardContent,
} from "@mui/material/";

import {
  CommonSubHeader,
  normalizeText,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";

import ObservationsCards from "../../Components/ObservationsCards";

//date
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";
import api from "../../api/axios";
import {
  buscarDuplicados,
  hasImportantChanges,
  hasNormalClientChanges,
  notesHistoricLogic,
  nuevoArrayDeNotas,
} from "../../Components/helpers/ContactPlusClient/ContactNClientsHelpers";
import DuplicatedAlertList from "../../Components/helpers/ContactPlusClient/DuplicatedAlertList";
import ContactClientNotesComparisonDialog from "../../Components/ContactClientNotesComparisonDialog";
import {
  PermissionContext,
  UserContext,
} from "../../Components/Context/Context";
import { TableChart, Visibility } from "@mui/icons-material";
import { Save } from "lucide-react";
import { Link } from "react-router-dom";
import Unauthorized from "../../Components/Common/Design/Unauthorized";

const EditarCliente = ({
  transferCase = false,
  setMultipleClients = [],
  handleClientTransfer,
  setClientTransferData,
  setTransferedClientsInfo = [],
  setActualClientinfo = [],
  clientCreated = false,
  setCurrentClientTransfer,
}) => {
  const Swal = require("sweetalert2");
  const { userData } = useContext(UserContext);
  const { user } = userData;
  const { can } = useContext(PermissionContext);
  const hasPermission = can("clients", "edit");

  const { goView, goTable } = useLocationHelpers();
  const navigate = useNavigate();

  // TAKE ZONES DATA
  // SAVE URL
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("id");

  const [selectedCheckboxNotes, setSelectedCheckboxNotes] = useState("");

  // TAKE VALUES
  const [clientData, setClientData] = useState({
    // ================== TEXTOS ==================
    email: "",
    name: "",
    surname: "",
    address: "",
    postalcode: "",
    document: "",
    phone: "",
    observations: "",

    // ================== LOCATION ==================
    province: {
      provincia: "Seleccionar",
      id_provincia: 0,
    },

    // ================== RELACIONES ==================
    company: {
      company_name: "Seleccionar",
      id: 0,
    },
    document_type: {
      name: "Seleccionar",
      id: 0,
    },
    association: {
      asoc_name: "Seleccionar",
      id: 0,
    },
    zone: {
      zona: "Seleccionar",
      id: 0,
    },
    status: {
      nombre: "Seleccionar",
      id: -1,
    },
    // office: {
    //   office_name: "Seleccionar",
    //   id: 0,
    // },

    lawyer: {
      id: 0,
      name: "Seleccionar",
      surname: "",
    },

    // ================== EXTRAS ==================
    cards: [],
  });

  const [oldClientData, setOldClientData] = useState({});

  const [marketingtoSend, setMarketingToSend] = useState("");

  // Flag primer render
  const [flag, setFlag] = useState(false);
  // Flag si encuentra multiples contactos asociados al cliente.
  const [multipleContacts, setMultipleContacts] = useState([]);
  const [multipleCli, setMultipleCli] = useState([]);
  // Flag que controla la gestion de las notas (Observaciones)
  const [showNotes, setShowNotes] = useState(false);
  const [flagContactFounded, setFlagContactFounded] = useState(null);
  const [flagClientNoExistence, setFlagClientNoExistence] = useState(false);

  const [changeOptionsFlag, setChangeOptionsFlag] = useState(false);
  const [changeRender, setChangeRender] = useState(false);

  const [dateInDefault, setDateInDefault] = useState();
  const [dateInFilter, setDateInFilter] = useState(0);

  const [statuses, setStatuses] = useState([
    {
      nombre: "Seleccionar",
      id: -1,
    },
    {
      nombre: "Inactivo",
      id: 0,
    },
    {
      nombre: "Activo",
      id: 1,
    },
  ]);

  const contactStatus = [
    { nombre: "Pte Llamada", id: 0 },
    { nombre: "Llamado", id: 1 },
    { nombre: "Cliente", id: 2 },
    { nombre: "Cancelado", id: 3 },
  ];

  const [newCompaniesArray, setNewCompaniesArray] = useState([]);
  const [contactData, setContactData] = useState([]);

  const [valCaseTypeForm, setValCaseTypeForm] = useState("");
  const [titleObservation, setTitleObservation] = useState(false);

  const [options, setOptions] = useState({
    companies: [],
    lawyers: [],
    status: [],
    provinces: [],
    zones: [],
    associations: [],
    // offices: [],
  });

  const [flagCompanySelected, setFlagCompanySelected] = useState(true);

  const [differentNotes, setDifferentNotes] = useState([]);
  const [flagToReload, setFlagToReload] = useState(false);

  const [flagSameDocument, setFlagSameDocument] = useState(false);
  const [sameNifForbidden, setSameNifForbidden] = useState(false);

  // --- OBTENER DATOS DEL CLIENTE Y MANEJAR HISTÓRICO ---
  const getDataList = async () => {
    setFlag(false);
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/users/edit`,
        { id: clientId },
      );
      const {
        client = {},
        observations_contact = [],
        multiple_contacts = [],
        multiple_clients = [],
        provinces = [],
        companies = [],
        associations = [],
        lawyers = [],
        // offices = [],
        document_types = [],
      } = data || {};

      console.log(data);

      const sameNifContacts = client?.nif
        ? multiple_contacts.filter((c) => c.nif === client?.nif && c.nif != "")
        : [];

      console.log(sameNifContacts);

      setSameNifForbidden(sameNifContacts);

      // --- Flags y configuraciones básicas ---
      setFlagClientNoExistence(multiple_clients.length === 0 && !client);
      setMultipleContacts(
        multiple_contacts.length > 1 ? multiple_contacts : [],
      );
      setMultipleCli(multiple_clients.length > 0 ? multiple_clients : []);
      setContactData(
        multiple_contacts.length === 1 ? multiple_contacts[0] : [],
      );

      // --- Destructuración del cliente ---
      const {
        id,
        name = "",
        surname = "",
        email = "",
        address = "",
        province: provinceValue = "",
        postalcode = "",
        nif = "",
        phone = "",
        notas = "",
        marketing = 0,
        lawyers_relation,
        company_relation,
        // offices_relation,
        asociations_relation,
        zones_relation,
        date_in = "",
        transfer_id = null,
        status: clientStatusVal = -1,
      } = client;

      // --- Helpers inline ---
      const getRelation = (rel, def) => (rel?.id ? rel : def);
      const companiesArr = companies.some((c) => c.id === 0)
        ? companies
        : [{ company_name: "Seleccionar", id: 0 }, ...companies];
      const status = statuses.find((s) => s.id === clientStatusVal) || {
        nombre: "Seleccionar",
        id: -1,
      };

      console.log(getRelation(client?.document_types_relation));

      // --- Datos seguros y observaciones ---
      const clientDataObj = {
        id,
        name,
        surname,
        email,
        address,
        postalcode,
        document: nif,
        document_type: getRelation(client?.document_types_relation),
        phone,
        transfer_id,
        province: provinceValue
          ? { provincia: provinceValue }
          : { provincia: "Seleccionar", id_provincia: 0 },
        company: getRelation(company_relation, {
          company_name: "Seleccionar",
          id: 0,
        }),
        lawyer: getRelation(lawyers_relation, {
          id: 0,
          name: "Seleccionar",
          surname: "",
        }),
        // office: getRelation(offices_relation, {
        //   office_name: "Seleccionar",
        //   id: 0,
        // }),
        association: getRelation(asociations_relation, {
          asoc_name: "Seleccionar",
          id: 0,
        }),
        zone: getRelation(zones_relation, { zona: "Seleccionar", id: 0 }),
        status,
        // observations: normalizarObservaciones(
        //   notas,
        //   date_in,
        //   client,
        //   arrayToStatus,
        //   multiple_contacts[0]?.id || 0,
        //   clientId,
        //   "cliente"
        // ),
        cards: [
          ...(nuevoArrayDeNotas(observations_contact).conClave || []),
          ...(nuevoArrayDeNotas(observations_contact).sinClave || []),
        ],
      };

      console.log(clientDataObj);

      // --- Filtrado por empresa ---
      // if (clientDataObj.company?.id)
      //   filterDataByCompany(clientDataObj.company.id);

      // --- Caso de transferencia ---
      setOldClientData(clientDataObj);

      if (transferCase) {
        const reset = { id: 0, name: "Seleccionar", surname: "" };
        setClientData({
          ...clientDataObj,
          company: { company_name: "Seleccionar", id: 0 },
          lawyer: reset,
          association: { asoc_name: "Seleccionar", id: 0 },
          // office: { office_name: "Seleccionar", id: 0 },
        });
        setClientTransferData(clientDataObj);
        setOptions({
          status: statuses,
          provinces: provinces,
        });
        setCurrentClientTransfer(clientDataObj);
      } else {
        setOptions({
          companies: companiesArr,
          status: statuses,
          provinces: provinces,
        });
        setClientData(clientDataObj);
      }

      // GeneralOptions
      setOptions((prevData) => ({
        ...prevData,
        lawyers: [{ name: "Seleccionar", surname: "", id: 0 }, ...lawyers],
        associations: [{ asoc_name: "Seleccionar", id: 0 }, ...associations],
        // offices: [{ office_name: "Seleccionar", id: 0 }, ...offices],
        document_types: [{ name: "Seleccionar", id: 0 }, ...document_types],
      }));

      setFlagCompanySelected(false);

      setMarketingToSend(marketing);

      // --- Manejo de notas históricas ---
      const cleaner = await notesHistoricLogic(
        multiple_contacts.length === 1 ? multiple_contacts[0] : null,
        client,
        setDifferentNotes,
      );

      if (
        multiple_contacts.length === 1 &&
        multiple_contacts[0]?.id &&
        clientDataObj?.company?.id == multiple_contacts[0]?.company_id
      ) {
        const sameDoc = client?.nif == multiple_contacts[0]?.nif;

        setFlagContactFounded(multiple_contacts[0]);
        setFlagSameDocument(sameDoc);
      }
      if (cleaner) setFlagToReload((prev) => !prev);
    } catch (error) {
      console.error("Error fetching client data:", error);
      setFlagClientNoExistence(true);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo obtener la información del cliente.",
      });
    } finally {
      setFlag(true);
    }
  };

  const getDataListToTransfer = async (actualUrl, client) => {
    if (client?.document) {
      // Mostrar alerta de carga
      try {
        const url = `${actualUrl}/users/search`;
        const { data } = await api.post(url, { document: client.document });

        // console.log(data);
        const urlCompanies = `${actualUrl}/companies/all`;
        const { data: dataCompanies } = await api.post(urlCompanies);

        const documents = data?.document || [];
        const companies = dataCompanies?.companies || [];

        console.log(documents, "documents");
        console.log(dataCompanies?.companies, "dataCompanies?.companies");
        // Obtener clientes transferidos para definir datos en transfer client - case
        const clientesTransferidos = documents
          .filter(
            (item) => oldClientData?.company?.id !== item.company_relation.id,
          )
          .map((item) => ({
            ...item,
            company_id: item.company_relation.id,
            company_name: item.company_relation.company_name,
            flag: true,
          }));

        const clientesActual = documents.filter(
          (item) => oldClientData?.company?.id === item.company_relation.id,
        );

        // Filtrar clientes transferidos para definir datos en transfer client - case
        const filteredCompanies = companies.filter((company) => {
          // Excluye la empresa actual y las que ya están en clientesTransferidos
          return (
            company.id !== clientesActual[0]?.company_id &&
            !clientesTransferidos.some((doc) => doc.company_id === company.id)
          );
        });

        console.log(clientesActual);
        console.log(clientesTransferidos);
        console.log(filteredCompanies);

        setTransferedClientsInfo(clientesTransferidos);
        setActualClientinfo(clientesActual);
        setNewCompaniesArray(filteredCompanies);

        setOptions((prev) => ({
          ...prev,
          companies: [
            { company_name: "Seleccionar", id: 0 },
            ...filteredCompanies,
          ],
        }));

        if (data?.document?.length > 1) {
          setMultipleClients(data.document);
        } else {
          setMultipleClients([]);
        }
      } catch (error) {
        console.error("Error cargando clientes múltiples:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo cargar la información.",
          confirmButtonColor: "#1ab394",
        });
      }
    }
  };

  // HANDLE DATA
  const guardarCliente = async (
    clientData,
    updateContactFromDocument = false,
  ) => {
    const fields = {
      id: clientId,
      email: clientData.email,
      name: clientData.name,
      surname: clientData.surname,
      address: clientData.address,
      postalcode: clientData.postalcode,
      nif: clientData.document,
      phone: clientData.phone,
      marketing: marketingtoSend || 0,
      lawyer: clientData.lawyer?.id,
      province: clientData.province?.id_provincia
        ? clientData.province?.provincia
        : "",
      // office_id: clientData.office.id,
      zone: clientData.zone.id,
      company_id: clientData.company.id,
      asociation: clientData.association.id,
      status: clientData.status?.id || 0,
      document_type: clientData.document_type?.id || 0,
    };
    console.log(fields);

    const formData = new FormData();
    Object.entries(fields).forEach(([k, v]) => formData.append(k, v));

    if (updateContactFromDocument == false) {
      const confirm = await Swal.fire({
        title: "¿Desea guardar los cambios?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Continuar",
        denyButtonText: "Volver",
        reverseButtons: true,
        confirmButtonColor: "#1ab394",
      });
      if (!confirm.isConfirmed) return;
    }

    try {
      Swal.fire({
        title: "Guardando información...",
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      });

      await api.post(`${process.env.REACT_APP_API_URL}/users/update`, formData);

      Swal.fire({
        title: "¡Guardado correctamente!",
        icon: "success",
        timer: 3000,
        showConfirmButton: false,
      }).then(() => navigate("/clientes/ver?id=" + clientId));
    } catch {
      Swal.fire({
        title: "Error",
        icon: "error",
        text: "No se pudo guardar el cliente",
        confirmButtonColor: "#d33",
      });
    }
  };

  const handleUpdateContact = async () => {
    const fields = {
      nif: clientData?.document,
      contact_id: flagContactFounded?.id,
    };

    console.log(flagContactFounded);

    const formData = new FormData();
    Object.entries(fields).forEach(([k, v]) => {
      if (v !== undefined && v !== null) {
        formData.append(k, v);
      }
    });

    const { isConfirmed } = await Swal.fire({
      title: "¿Actualizar documento del contacto asociado?",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Continuar",
      denyButtonText: "Volver",
      reverseButtons: true,
      confirmButtonColor: "#1ab394",
    });

    if (!isConfirmed) return false;

    // Loader persistente
    Swal.fire({
      title: "Guardando información...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/contacts/update`,
        formData,
      );

      Swal.fire({
        title: "Éxito",
        icon: "success",
        text: "Contacto actualizado correctamente",
        confirmButtonColor: "#1ab394",
      });

      return response.data;
    } catch (error) {
      // 🧠 Extraer mensaje real del backend si existe
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "No se pudo guardar el contacto";

      Swal.fire({
        title: "Error",
        icon: "error",
        text: message,
        confirmButtonColor: "#d33",
      });

      console.error("Update contact error:", error);
      return false;
    }
  };

  const handleClientsFormInformation = async () => {
    const baseUrl = `${process.env.REACT_APP_API_URL}/users/searchclient`;

    const queryParams = {
      email: clientData?.email,
      document: clientData?.document,
      phone: clientData?.phone,
      id: clientId,
    };

    const importantChanges = hasImportantChanges(clientData, oldClientData);

    const normalInfoChanges = hasNormalClientChanges(clientData, oldClientData);

    const noChangesDetected = !importantChanges && !normalInfoChanges;

    if (noChangesDetected) {
      Swal.fire({
        title: "Sin cambios",
        text: "No se ha detectado ningún cambio en la información del cliente.",
        icon: "info",
        confirmButtonColor: "#1ab394",
      });
      return;
    }

    console.log(flagSameDocument, clientData?.document, oldClientData?.nif);
    if (flagSameDocument && clientData?.document !== oldClientData?.document) {
      const decision = await Swal.fire({
        title: "¡Cuidado!",
        html: `
      <div style="text-align: left;">
      <p>
        Ha cambiado el <b>Documento</b> y ya existe un contacto asociado
        a este cliente con el mismo documento.
      </p>
      <p>
        Si continúa, el cliente <b>perderá la relación</b> y no podrá
        compartir notas.
      </p>
      <p>
        <b>Recomendación:</b> Actualice el documento del contacto para mantener la relación.
      </p>
      </div>
    `,
        icon: "warning",
        showDenyButton: true,
        showCancelButton: true,

        confirmButtonText: "Continuar",
        denyButtonText: "Actualizar contacto y continuar",
        cancelButtonText: "Cancelar",

        confirmButtonColor: "#1ab394", // rojo → acción destructiva
        denyButtonColor: "#0288d1", // verde → recomendada
        cancelButtonColor: "#d33",

        allowOutsideClick: false,
        allowEscapeKey: false,
        reverseButtons: true,
      });

      //  Cancelar → no hace nada
      if (decision.dismiss === Swal.DismissReason.cancel) return;

      // Actualizar cliente (recomendado)
      if (decision.isDenied) {
        var updateContact = await handleUpdateContact();

        console.log(updateContact);
        if (!updateContact) return;

        await Swal.fire({
          title: "Contacto actualizado",
          text: "Actualizando contacto...",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      }

      // Continuar → rompe relación
      if (decision.isConfirmed) {
        // continuar flujo normal
      }
    }

    let canContinue = true;

    /* ================= BUSCAR DUPLICADOS ================= */
    if (importantChanges) {
      canContinue = await buscarDuplicados({
        baseUrl,
        queryParams,
        clientId,
        setClientData,
        incomingSite: "clientes",
      });

      if (!canContinue) return;
    }

    /* ================= VALIDACIONES ================= */
    if (clientData.company.id === 0) {
      Swal.fire({
        title: "¡Seleccione una empresa!",
        icon: "warning",
        confirmButtonColor: "#1ab394",
      });
      return;
    }

    const requiredFields = {
      name: !clientData?.name,
      surname: !clientData?.surname,
      address: !clientData?.address,
      postalcode: !clientData?.postalcode,
      document: !clientData?.document,
      phone: !clientData?.phone,
      email: !clientData?.email,
      lawyer: !clientData?.lawyer?.id,
      province: !clientData?.province?.provincia,
      company: !clientData?.company?.id,
      status: !clientData?.status?.id,
      document_type: !clientData?.document_type?.id,
    };

    console.log(requiredFields);

    if (Object.values(requiredFields).includes(true)) {
      const labels = {
        company: "Empresa",
        lawyer: "Abogado",
        name: "Nombre",
        surname: "Apellido",
        phone: "Teléfono",
        province: "Provincia",
        email: "Email",
        address: "Dirección",
        postalcode: "Código postal",
        document: "Documento",
        document_type: "Tipo de documento",
        status: "Estado",
      };

      const missing = Object.keys(requiredFields)
        .filter((k) => requiredFields[k])
        .map((k) => `<li>${labels[k]}</li>`)
        .join("");

      return Swal.fire({
        title: "Campos incompletos",
        icon: "error",
        confirmButtonColor: "#1ab394",
        html: `<ul style="text-align:left">${missing}</ul>`,
      });
    }

    /* ================= GUARDAR ================= */
    await guardarCliente(clientData, updateContact || false);
  };

  const handleChangeCheckbox = (event) => {
    if (event.target.checked == true) {
      setMarketingToSend(1);
    } else {
      setMarketingToSend(0);
    }
  };

  const updateClientData = (key, value) => {
    setClientData((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (transferCase) {
      setClientTransferData((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  const handleContactsToHistorical = async () => {
    const dateUpdate = new Date();
    const newDateUpdate = dayjs(dateUpdate).format("YYYY-MM-DD HH:mm:ss"); // Devuelve "2024-11-24"

    if (selectedCheckboxNotes == "") {
      Swal.fire({
        title: "¡Error!",
        icon: "warning",
        text: "Por favor seleccione el tipo de nota.",
        showDenyButton: false,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Continuar",
      });
    } else if (valCaseTypeForm.trim() == "") {
      Swal.fire({
        title: "¡Error!",
        icon: "warning",
        text: "No se ha agregado ningún texto a la nota",
        showDenyButton: false,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Continuar",
      });
    } else {
      // Define la estructura de como se va a visualizar la ultima nota, la cual esta guardada sobre el mismo registro del contacto,
      // el resto de registros serán guardados en el historico

      const date = new Date();
      const created_at = dayjs(date).format("YYYY-MM-DD"); // Devuelve "2024-11-24"

      console.log(contactData);
      console.log(clientData);

      let historicalData = {
        user_id: 0,
        document: clientData?.document || "",
        lawyer: clientData?.lawyer?.id || 0,
        contact_id: contactData?.id || 0,
        company_id: clientData?.company?.id
          ? clientData?.company?.id
          : oldClientData
            ? oldClientData
            : 0,
        status: contactData?.status || 0,
        case_type: 0,
        created_by: user?.id || 0,
        created_at: dateInFilter
          ? dayjs(dateInFilter).format("YYYY-MM-DD HH:mm:ss")
          : newDateUpdate,
        notas: valCaseTypeForm.trim() || "",
        title: titleObservation || "",
        note_type: selectedCheckboxNotes || "none",
      };

      Swal.fire({
        title: "¿Desea guardar la nota?",
        showDenyButton: true,
        icon: "warning",
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        confirmButtonText: "Continuar",
        denyButtonText: "Volver",
        preConfirm: () => {
          try {
            if (clientData?.notas?.trim() != "") {
              const historical = api
                .post(
                  `${process.env.REACT_APP_API_URL}/contacts/create_historical`,
                  historicalData,
                )
                .then((response) => {
                  console.log(response);
                });
              console.log(historical);
            }
          } catch (error) {
            console.log(error);
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "¡Guardado!",
            icon: "success",
            html: "¿Seguir editando?",
            showDenyButton: true,
            confirmButtonText: "Continuar",
            denyButtonText: "No, volver a la tabla",
            confirmButtonColor: "#1ab394",
            cancelButtonColor: "#d33",
            reverseButtons: true,
          }).then((result) => {
            if (result.isDenied) {
              navigate("/contactos");
            } else {
              setShowNotes(false);
              setValCaseTypeForm("");
              setSelectedCheckboxNotes("");
              setChangeRender(!changeRender);
            }
          });
        } else if (result.isDenied) {
          Swal.fire({
            title: "¡Los cambios no han sido guardados!",
            icon: "error",
            showDenyButton: false,
            confirmButtonText: "Continuar",
            confirmButtonColor: "#1ab394",
          });
          setDateInFilter(false);
        }
      });
    }
  };

  const handleChangeDateIn = (newValue) => {
    if (newValue && dayjs.isDayjs(newValue)) {
      // Agrega la hora actual al objeto dayjs de la fecha seleccionada
      const dateWithCurrentTime = newValue
        .hour(dayjs().hour())
        .minute(dayjs().minute())
        .second(dayjs().second());

      // Convierte el objeto dayjs con hora a un string en el formato deseado
      const formattedDate = dateWithCurrentTime.format("YYYY-MM-DD HH:mm:ss");

      setDateInDefault(dateWithCurrentTime); // Guarda la fecha con hora
      setDateInFilter(formattedDate); // Guarda la fecha como string con hora
    } else {
      setDateInFilter(null);
      console.error("El nuevo valor no es un objeto dayjs");
    }
  };

  //////////////////// FILTER BY COMPANY  ///////////////////////
  const filterDataByCompany = (company_id, flagFromCompanyInput = false) => {
    console.log(company_id);

    if (company_id && company_id !== 0) {
      try {
        let queryUrl = `${process.env.REACT_APP_API_URL}/users/searchdatabycompany`;

        api.post(queryUrl, { company: company_id }).then((response) => {
          if (response.data) {
            const {
              // offices,
              associations,
              lawyers,
            } = response.data;

            console.log(response.data);

            setOptions((prevData) => ({
              ...prevData,
              lawyers: [
                { name: "Seleccionar", surname: "", id: 0 },
                ...lawyers,
              ],
              associations: [
                { asoc_name: "Seleccionar", id: 0 },
                ...associations,
              ],
              // offices: [{ office_name: "Seleccionar", id: 0 }, ...offices],
            }));

            if (flagFromCompanyInput) {
              setClientData((prev) => ({
                ...prev,
                association: { asoc_name: "Seleccionar", id: 0 },
                // office: { office_name: "Seleccionar", id: 0 },
                lawyer: { id: 0, name: "Seleccionar", surname: "" },
              }));
            }

            setFlagCompanySelected(false);
            setChangeOptionsFlag(!changeOptionsFlag);
          }
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      // Si no hay empresa seleccionada, limpiar las opciones y bloquear los campos
      setFlagCompanySelected(true);
    }
  };

  //////////////////// FILTER BY COMPANY  ///////////////////////

  const fieldsConfig = useMemo(() => {
    var fieldsCommonConfig = [];

    if (selectedCheckboxNotes === "contact-register") {
      fieldsCommonConfig = [
        {
          type: "date",
          label: "Nueva fecha de ingreso",
          helpText:
            "Solo modificar si se desea guardar en una fecha específica. Por defecto se guardará la fecha de hoy.",
          value: dateInDefault,
          id: "date_in",
          disabled: true,
          onChange: (event) => setDateInDefault("date_in", event.target.value),
          grid: 12,
        },
      ];
    } else if (selectedCheckboxNotes != "contact-register") {
      fieldsCommonConfig = [
        {
          grid: 5,
          value: clientData?.company || { id: 0, company_name: "Seleccionar" },
          className: "companyId noBorderRadius fontSize",
          label: "Empresa",
          onChange: (event, value) => {
            const selected = value || { id: 0, company_name: "Seleccionar" };
            updateClientData("company", selected);
            updateClientData("lawyer", {
              name: "Seleccionar",
              surname: "",
              id: 0,
            });
            // updateClientData("office", { office_name: "Seleccionar", id: 0 });
            updateClientData("association", {
              asoc_name: "Seleccionar",
              id: 0,
            });
            filterDataByCompany(selected?.id || 0, true);
          },
          options: options.companies || [],
          isOptionEqualToValue: (option, value) => option?.id === value?.id,
          getOptionLabel: (option) => option?.company_name || "Seleccionar",
          type: "autocomplete",
        },
        {
          grid: 7,
          value: clientData?.lawyer || {
            name: "Seleccionar",
            surname: "",
            id: 0,
          },
          className: "selectWithInput noBorderRadius fontSize",
          label: "Abogado",
          onChange: (event, value) => {
            const selected = value || {
              name: "Seleccionar",
              surname: "",
              id: 0,
            };
            updateClientData("lawyer", selected);
          },
          options: options.lawyers || [],
          isOptionEqualToValue: (option, value) =>
            option?.id === value?.id ||
            option?.name + " " + option?.surname ===
              value?.name + " " + value?.surname,
          getOptionLabel: (option) =>
            option?.name + " " + option?.surname || "Seleccionar",
          type: "autocomplete",
          disabled: flagCompanySelected,
        },
        {
          value: clientData?.association || { id: 0, asoc_name: "Seleccionar" },
          className: "asociationsId noBorderRadius fontSize",
          label: "Asociaciones",
          onChange: (event, value) => {
            const selected = value || { id: 0, asoc_name: "Seleccionar" };
            updateClientData("association", selected);
          },
          options: options.associations || [],
          isOptionEqualToValue: (option, value) => option?.id === value?.id,
          getOptionLabel: (option) => option?.asoc_name || "Seleccionar",
          type: "autocomplete",
          disabled: flagCompanySelected ?? !clientData?.company?.id,
        },
        // {
        //   value: clientData?.office || { id: 0, office_name: "Seleccionar" },
        //   className: "clientData.status noBorderRadius fontSize",
        //   label: "Despacho",
        //   onChange: (event, value) => {
        //     const selected = value || { id: 0, office_name: "Seleccionar" };
        //     updateClientData("office", selected);
        //   },
        //   options: options.offices || [],
        //   isOptionEqualToValue: (option, value) => option?.id === value?.id,
        //   getOptionLabel: (option) => option?.office_name || "Seleccionar",
        //   type: "autocomplete",
        //   disabled: flagCompanySelected ?? !clientData?.company?.id,
        // },
        {
          value: clientData?.status || { id: 0, nombre: "Seleccionar" },
          className: "clientData.status noBorderRadius fontSize",
          label: "Estado",
          onChange: (event, value) => {
            const selected = value || { id: 0, nombre: "Seleccionar" };
            updateClientData("status", selected);
          },
          options: statuses || [],
          isOptionEqualToValue: (option, value) => option?.id === value?.id,
          getOptionLabel: (option) => option?.nombre || "Seleccionar",
          type: "autocomplete",
        },
        {
          value: clientData?.email || "",
          type: "text",
          id: "emailId",
          label: "Email",
          // disabled: transferCase || !clientData?.email ? true : false,
          // disabled: transferCase,
          onChange: (event) => {
            updateClientData("email", event.target.value || "");
          },
        },
        {
          grid: 6,
          value: clientData?.name || "",
          type: "text",
          id: "nameId",
          label: "Nombre",
          disabled: transferCase,
          onChange: (event) => {
            updateClientData("name", event.target.value || "");
          },
        },
        {
          grid: 6,
          value: clientData?.surname || "",
          type: "text",
          id: "surnameId",
          label: "Apellido",
          disabled: transferCase,
          onChange: (event) => {
            updateClientData("surname", event.target.value || "");
          },
        },
        {
          grid: 7,
          value: clientData?.address || "",
          type: "text",
          id: "addressId",
          label: "Dirección",
          disabled: transferCase,
          onChange: (event) => {
            updateClientData("address", event.target.value || "");
          },
        },
        {
          grid: 5,
          value: clientData?.postalcode || "",
          type: "text",
          id: "postalCodeId",
          label: "Código postal",
          disabled: transferCase,
          onChange: (event) => {
            updateClientData("postalcode", event.target.value || "");
          },
          inputProps: { maxLength: 10 },
        },
        {
          value: clientData?.phone || "",
          type: "text",
          id: "phoneId",
          label: "Teléfono",
          disabled: transferCase,
          onChange: (event) => {
            updateClientData("phone", event.target.value || "");
          },
        },
        {
          id: "document_type",
          key: "document_type",
          value: clientData?.document_type || { id: 0, name: "Seleccionar" },
          type: "autocomplete",
          label: "Tipo",
          className: "documentTypeId",
          grid: 4,
          options: options?.document_types || [],
          onChange: (event, value) => {
            const selected = value || { id: 0, name: "Seleccionar" };
            console.log(selected);
            updateClientData("document_type", selected || null);
          },
          isOptionEqualToValue: (option, value) => option.id === value?.id,
          getOptionLabel: (option) => option.name || "Seleccionar",
        },
        {
          value: clientData?.document || "",
          type: "text",
          grid: 8,
          id: "niffId",
          label: "Documento",
          onChange: (event) => {
            updateClientData("document", event.target.value || "");
          },
          className: "inputFormCreateWithTextBelow",
        },
        {
          value: clientData?.province || {
            id_provincia: 0,
            provincia: "Seleccionar",
          },
          className: "selectWithInput noBorderRadius fontSize",
          label: "Provincia",
          onChange: (event, value) => {
            const selected = value || {
              provincia: "Seleccionar",
              id_provincia: 0,
            };
            updateClientData("province", selected);
          },
          options: options.provinces || [],
          isOptionEqualToValue: (option, value) =>
            option?.provincia === value?.provincia,
          getOptionLabel: (option) => option?.provincia || "Seleccionar",
          type: "autocomplete",
        },
      ];
    }

    return fieldsCommonConfig;
  }, [
    showNotes,
    clientData,
    changeOptionsFlag,
    selectedCheckboxNotes,
    newCompaniesArray,
  ]); // Dependencia para que se actualice al cambiar el estado

  const commonButtonProps = {
    size: "small",
    sx: { width: "100%", padding: "5px 20px !important" },
  };

  const handleChangeSelectedNewNoteType = (event) => {
    setSelectedCheckboxNotes(
      event?.target.value == 1 ? "normal" : "contact-register",
    );
  };

  // SET VARIABLES
  useEffect(() => {
    if (!hasPermission) {
      return;
    }

    getDataList();
  }, [changeRender, flagToReload]);

  useEffect(() => {
    if (transferCase) {
      console.log("ENTRA A TRANSFER");
      const actualUrl = process.env.REACT_APP_API_URL;
      getDataListToTransfer(actualUrl, clientData);
    }
  }, [transferCase, flag, clientCreated]);

  const uniqueRelation =
    flagSameDocument &&
    flagContactFounded?.id &&
    !transferCase &&
    flagContactFounded?.company_id == clientData?.company?.id;

  console.log(uniqueRelation);

  const content = (
    <Fade timeout={800} in={flag}>
      <Grid container>
        {/* ================= CLIENTE NO EXISTE ================= */}
        {flagClientNoExistence && (
          <Grid container item xs={12}>
            <Grid item xs={12}>
              <Alert severity="error">El cliente no existe...</Alert>
            </Grid>
          </Grid>
        )}

        {!flagClientNoExistence && (
          <>
            {/* ================= ALERTAS SUPERIORES ================= */}
            <Grid item xs={12}>
              {uniqueRelation && (
                <Grid item xs={12} sx={{ mb: 2 }}>
                  <Alert severity="info" className="alertStyles">
                    <span>
                      Se ha encontrado un contacto asociado a este cliente,
                      click si desea verlo:
                    </span>
                    <Button
                      component={NavLink}
                      to={`/contactos/ver?id=${flagContactFounded?.id}`}
                      size="small"
                      color="info"
                      variant="outlined"
                      sx={{ ml: 2 }}>
                      Ver Contacto
                    </Button>
                  </Alert>
                </Grid>
              )}

              <Grid container spacing={1} sx={{ padding: "10px 40px" }}>
                {multipleContacts?.length > 1 && (
                  <DuplicatedAlertList
                    items={multipleContacts}
                    entityName="contacto"
                    createNoteButton={true}
                  />
                )}
                {multipleCli.length > 0 && (
                  <DuplicatedAlertList
                    items={multipleCli}
                    entityName="cliente"
                  />
                )}
              </Grid>
            </Grid>

            {/* ================= FORM ================= */}
            <Box
              component="form"
              className="formMainContainer"
              noValidate
              autoComplete="off">
              <Grid container spacing={2} className="fontSize">
                {/* ================= COLUMNA IZQUIERDA ================= */}
                <Grid container item xs={5} spacing={1}>
                  {showNotes && (
                    <Grid item xs={12} sx={{ mb: "10px" }}>
                      <Typography variant="span">
                        Por favor elija una empresa para habilitar otros campos.
                      </Typography>
                    </Grid>
                  )}

                  {fieldsConfig.map(
                    (field, index) =>
                      (field?.type == "date" || !showNotes) && (
                        <Grid
                          item
                          xs={field?.grid ? field?.grid : 12}
                          key={index}>
                          {field.type === "autocomplete" ? (
                            <Autocomplete
                              value={field.value}
                              onChange={field.onChange}
                              disabled={showNotes || field.disabled}
                              size="small"
                              open={field.open}
                              options={field.options}
                              isOptionEqualToValue={field.isOptionEqualToValue}
                              getOptionLabel={field.getOptionLabel}
                              className={field.className}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={field.label}
                                  fullWidth
                                />
                              )}
                            />
                          ) : field.type === "date" ? (
                            <LocalizationProvider
                              dateAdapter={AdapterDayjs}
                              adapterLocale="es">
                              <DesktopDatePicker
                                disabled={!showNotes}
                                value={field.value}
                                label={field.label}
                                onChange={handleChangeDateIn}
                                sx={{ width: "100%", mb: 1 }}
                                slotProps={{
                                  textField: {
                                    helperText: field.helpText,
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          ) : (
                            <TextField
                              value={field.value}
                              onChange={field.onChange}
                              size="small"
                              label={field.label}
                              disabled={showNotes || field.disabled}
                              fullWidth
                              className={field.className}
                              inputProps={field.inputProps}
                            />
                          )}
                        </Grid>
                      ),
                  )}
                  {/* ================= CREAR NOTA (IZQUIERDA) ================= */}

                  {/* ================= COLUMNA NOTAS ================= */}
                  {showNotes && (
                    <Grid item xs={12}>
                      <Divider sx={{ width: "100%", mb: "10px" }} />

                      <Card
                        variant="outlined"
                        sx={{
                          opacity: showNotes ? 1 : 0.6,
                          pointerEvents: showNotes ? "auto" : "none",
                          transition: "0.3s",
                        }}>
                        <CardContent>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mb={2}>
                            <Typography fontWeight={700} m={"auto"}>
                              Nueva observación
                            </Typography>
                          </Box>

                          <Divider sx={{ mb: 2 }} />

                          {!showNotes && differentNotes?.length > 0 && (
                            <Alert severity="warning" sx={{ mb: 2 }}>
                              El cliente y el contacto tienen notas diferentes.
                              Unifique las notas para habilitar la creación.
                              <ContactClientNotesComparisonDialog
                                notas={differentNotes}
                                client={flagContactFounded || []}
                                contact={contactData || []}
                                setFlagToReload={setFlagToReload}
                                flagToReload={flagToReload}
                              />
                            </Alert>
                          )}

                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <Box display="flex" gap={2}>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={
                                        selectedCheckboxNotes === "normal"
                                      }
                                      onChange={handleChangeSelectedNewNoteType}
                                      value={"1"}
                                    />
                                  }
                                  label="Anotación normal"
                                />
                                <FormControlLabel
                                  control={
                                    <Switch
                                      color="success"
                                      checked={
                                        selectedCheckboxNotes ===
                                        "contact-register"
                                      }
                                      onChange={handleChangeSelectedNewNoteType}
                                      value={"2"}
                                    />
                                  }
                                  label="El contacto se ha comunicado nuevamente"
                                />
                              </Box>
                            </Grid>

                            <Grid item xs={12}>
                              <TextField
                                label="Título"
                                size="small"
                                fullWidth
                                onChange={(e) =>
                                  setTitleObservation(e.target.value)
                                }
                              />
                            </Grid>

                            <Grid item xs={12} width={"100%"}>
                              <textarea
                                rows={10}
                                id="textareaid"
                                style={{
                                  width: "100%",
                                  resize: "none",
                                  borderRadius: "4px",
                                  border: "1px solid rgba(0,0,0,0.25)",
                                  padding: "10px",
                                  boxSizing: "border-box",
                                }}
                                value={valCaseTypeForm || ""}
                                onChange={(e) => {
                                  setValCaseTypeForm(e.target.value);
                                  updateClientData(
                                    "observations",
                                    e.target.value,
                                  );
                                }}
                              />
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}
                </Grid>

                {/* ================= COLUMNA DERECHA ================= */}
                <Grid
                  item
                  xs={7}
                  sx={{ maxHeight: "550px", overflow: "auto", pl: 2 }}>
                  <Grid item xs={12} sx={{ mb: 2 }}>
                    {sameNifForbidden?.length > 1 && (
                      <Alert
                        severity="warning"
                        sx={{
                          mb: 2,
                          borderRadius: 2,
                          fontSize: "0.9rem",
                          alignItems: "center",
                        }}>
                        Para habilitar las notas en un cliente con contactos
                        asociados, cada contacto debe contar con un documento de
                        identificación único (NIF, DNI, ID, etc.).
                        <br />
                        Para asignar un contacto único, utilice el mismo número
                        de identificación del cliente.
                      </Alert>
                    )}
                    {!showNotes && (
                      <Box textAlign="center">
                        <Button
                          variant="contained"
                          color="info"
                          size="small"
                          sx={{ width: "50%", fontWeight: 700 }}
                          disabled={differentNotes?.length > 0 || transferCase}
                          onClick={() => {
                            setShowNotes(true);
                            setValCaseTypeForm("");
                          }}>
                          {differentNotes?.length > 0 || transferCase
                            ? "NOTAS DESHABILITADAS"
                            : "Crear Nota"}
                        </Button>
                      </Box>
                    )}

                    <Typography fontWeight={700} mt={2} textAlign={"center"}>
                      OBSERVACIONES
                    </Typography>

                    {!showNotes && differentNotes?.length > 0 && (
                      <Alert severity="warning" sx={{ mt: 1 }}>
                        El cliente y el contacto tienen notas diferentes.
                        <ContactClientNotesComparisonDialog
                          notas={differentNotes}
                          client={clientData || []}
                          contact={flagContactFounded || []}
                          setFlagToReload={setFlagToReload}
                          flagToReload={flagToReload}
                        />
                      </Alert>
                    )}
                  </Grid>

                  {clientData?.cards?.map((obs, index) => {
                    const statusName =
                      contactStatus?.find((o) => o.id === obs.status)?.nombre ||
                      "Desconocido";

                    return (
                      <ObservationsCards
                        key={index}
                        contact_id={clientId}
                        company={obs?.company_relation?.company_name}
                        observationId={obs?.id}
                        created_by_name={obs?.created_by_relation?.name || "-"}
                        created_by_surname={
                          obs?.created_by_relation?.surname || "-"
                        }
                        created_by_object={obs?.created_by_relation}
                        date={obs?.created_at}
                        title={obs?.title}
                        content={obs?.notas}
                        caseType={obs.types_relation?.case_type}
                        status_name={statusName}
                        setChangeRender={setChangeRender}
                        setShowNotes={setShowNotes}
                        transferCase={transferCase}
                      />
                    );
                  })}
                </Grid>
              </Grid>

              {/* ================= BOTONES ================= */}
              <Divider sx={{ mt: 2 }} />

              <ButtonGroup fullWidth sx={{ mt: 2 }}>
                {/* ===== GUARDAR NOTA ===== */}
                {showNotes && (
                  <Button
                    onClick={handleContactsToHistorical}
                    variant="contained"
                    startIcon={<Save />}
                    color="success"
                    {...commonButtonProps}>
                    Guardar Nota
                  </Button>
                )}

                {/* ===== CANCELAR NOTA ===== */}
                {showNotes && (
                  <Button
                    onClick={() => {
                      setShowNotes(false);
                      setValCaseTypeForm("");
                      setSelectedCheckboxNotes("");
                    }}
                    color="error"
                    {...commonButtonProps}>
                    Cancelar Nota
                  </Button>
                )}

                {/* ===== GUARDAR CLIENTE ===== */}
                {!showNotes && !transferCase && (
                  <Button
                    onClick={handleClientsFormInformation}
                    variant="contained"
                    color="success"
                    startIcon={<Save />}
                    {...commonButtonProps}>
                    Guardar
                  </Button>
                )}

                {/* ===== VER CLIENTE ===== */}
                {!showNotes && (
                  <Button
                    component={Link}
                    to={`/clientes/ver?id=${clientId}`}
                    variant="outlined"
                    color="info"
                    startIcon={<Visibility />}
                    {...commonButtonProps}>
                    Ver
                  </Button>
                )}

                {/* ===== TABLA ===== */}
                {!showNotes && (
                  <Button
                    component={Link}
                    to="/clientes"
                    {...commonButtonProps}
                    variant="outlined"
                    startIcon={<TableChart />}
                    color="error">
                    Tabla
                  </Button>
                )}
              </ButtonGroup>
            </Box>
          </>
        )}
      </Grid>
    </Fade>
  );

  //////////////////// FILTER BY COMPANY  ///////////////////////
  return (
    <>
      <div className="fatherContainer">
        {!transferCase && (
          <CommonSubHeader title="Clientes" subTitle="Editar" />
        )}

        {!hasPermission && <Unauthorized />}
        {!flag && <LoadingPage isLoading={!flag} heightProp={"600px"} />}
        {flag && hasPermission && content}
      </div>
    </>
  );
};

export default EditarCliente;
